import React from "react";
import "./Footer.css";
import logo from "../../images/logo.png"; // Logo import
import logoText from "../../images/logoText.png"; // Text logo import
import { Link } from "react-router-dom";
import { FacebookShareButton, TelegramShareButton, ViberShareButton, WhatsAppShareButton } from "../../butttons/socialNetvorkButtons/socialNetvorkButtons";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + description */}
        <div className="footer-brand">
          <div className="logo">
        <Link to="/">
          <img src={logo} alt="Pryvitai Logo" style={{ height: '50px' }} /> <img src={logoText} alt="Pryvitai LogoText" style={{ height: '40px' }} />
        </Link>
      </div>
          <p>
            Your assistant in creating unforgettable greetings for any occasion.
          </p>
         {/* <div className="social-networks-footer">
               <ul className="social-networks-buttons-footer">
                 <li><FacebookShareButton /></li>
                 <li><TelegramShareButton /></li>
                 <li><ViberShareButton /></li>
                 <li><WhatsAppShareButton /></li>
               </ul>
             </div> */}
        </div>

        {/* Navigation */}
        <div className="footer-links">
          <div>
            <h4>Product</h4>
            <Link to="/calendar">Calendar</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/tariffs">Pricing</Link>
            <Link to="/actions">Promotions</Link>
            <Link to='/userpage'>Profile</Link>
          </div>
          {/* <div>
            <h4>Ресурси</h4>
            <a href="#">Допомога</a>
            <a href="#">FAQ</a>
            <a href="#">Блог</a>
            <a href="#">Підтримка</a>
          </div> */}
          <div>
            <h4>Company</h4>
            <Link to="/aboutUs">About Us</Link>
            <Link to="/userTips">User Tips</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/regulation">Terms and Conditions</Link>
            <Link to="/agreement">Privacy Policy</Link>

          </div>
        </div>
      </div>

      {/* Copyright */}
      {/* <div className="footer-bottom">
        © 2024 Привітання. Всі права захищено.
      </div> */}
    </footer>
  );
};

export default Footer;
